/**
 * Based on current interval and a total time, determine the next interval value.
 *
 * @param {Number} interval - current interval in ms
 * @param {Number} totalTimeSinceLastResult - time since last poll result was fetched in ms
 * @param {Number} initialInterval - intial start interval in ms
 * @param {Number} durationBeforeIntervalIncrease - how long to wait until we increase the interval
 * @returns {Number} new polling interval
 */
const calculateNewPollingInterval = ({
  interval,
  totalTimeSinceLastResult,
  initialInterval,
  durationBeforeIntervalIncrease,
}) => {
  // Since time either just begun or got reset, skip all calculations and
  // reset the interval
  if (totalTimeSinceLastResult === 0) {
    return initialInterval;
  }

  // Calculate the number of increase intervals that have passed
  const numberOfIncreaseIntervals =
    totalTimeSinceLastResult / durationBeforeIntervalIncrease;
  // Determine if we still haven't completed the current increase interval
  const hasReachedNextIncreaseInterval = numberOfIncreaseIntervals % 1 === 0;

  if (hasReachedNextIncreaseInterval) {
    return interval + initialInterval;
  } else {
    return interval;
  }
};

export default calculateNewPollingInterval;
